export default "__VITE_ASSET__TfWTqE3C__"